import CssBaseline from '@material-ui/core/CssBaseline';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import React from 'react';
import { addLocaleData } from 'react-intl';
import esLocaleData from 'react-intl/locale-data/es';
import AppContainer from './AppContainer';
import { SnackbarProvider } from 'notistack';
// import translations from './i18n/locales';

addLocaleData(esLocaleData);

// const locale = window.location.search.replace('?locale=', '') || 'en';
// const messages = translations[locale];

// https://material-ui.com/customization/themes/
const theme = createMuiTheme({
  typography: {
    useNextVariants: true
  },
  footerBackgroundColor: '#394242',
  footerTextColor: '#aaa',
  footerFontSize: '0.90rem'
});

class AppWrapper extends React.Component {
  // componentWillMount() {
  //   const locale = (this.props.store && this.props.store.getState().get('locale').get('lang')) || 'en';
  //   const messages = translations[locale];
  //   this.setState({locale, messages});
  // }

  render() {
    return (
      // <IntlProvider locale={this.state.locale} key={this.state.locale} messages={this.state.messages}>
      <React.Fragment>
        <CssBaseline />
        <MuiThemeProvider theme={theme}>
          <SnackbarProvider maxSnack={5}>
            <AppContainer
              store={this.props.store}
              history={this.props.history}
            />
          </SnackbarProvider>
        </MuiThemeProvider>
      </React.Fragment>
      // </IntlProvider>
    );
  }
}

export default AppWrapper;
